import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfigService } from '@app/services/config/config.service';
import { LocalStorageService } from '@app/services/local-storage.service';
import { ContentService } from 'app-classic/services/content.service';
import { ConfirmationDialogComponent as NewConfirmationDialogComponent } from '../../../app/components/confirmation-dialog/confirmation-dialog.component';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    standalone: false,
})
export class ConfirmationDialogComponent extends NewConfirmationDialogComponent {
    constructor(
        public _dialogRef: MatDialogRef<ConfirmationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: { title: string; description: string },
        private _contentService: ContentService,
        private _localStorageService: LocalStorageService,
        private readonly _configService: ConfigService
    ) {
        super(undefined as any, _data, _contentService, _localStorageService, _configService);
    }

    public onCancel(): void {
        this._dialogRef.close();
    }

    public onLogout(): void {
        this._contentService.sendData(this._contentService.logout);
        this._dialogRef.close();
        this.clearSSOAuthTokensFromCookies();
    }
}
